import { Badge } from './ui/badge';

/** Compact "used / max" chip for a subscription usage meter (SUB-005). Turns
 * amber at the plan limit. */
export function UsageMeter({ label, used, max }: { label: string; used: number; max: number }) {
  return (
    <Badge variant={used >= max ? 'warning' : 'neutral'}>
      {used} / {max} {label}
    </Badge>
  );
}
